export const PC_WIDTH = 768
export const zIndexLow = 10
export const zIndexMiddle = 20
export const zIndexHigh = 30
export const zIndexVeryHigh = 40
export const zIndexExtra = 50
export const zIndexExtraHigh = 60
export const zIndexMax = 100
export const zIndexNolPointPolicyModal = 199
export const zIndexPolicyModal = 199
